module.exports = __webpack_public_path__ + "static/media/20180523-LCS-057-4.96fd942b.jpg";